import React from "react";
import { Layout } from "../../components/Layout/Layout";
import "../../styles/tokens.css";
import "./index.css";
import SalesByMarketDashboard from "../../components/SalesByMarketDashboard";
import SalespersonSalaries from "../../components/SalespersonSalaries";


const Main: React.FC = () => {
  return (
    <Layout>
      <SalesByMarketDashboard />
      <SalespersonSalaries />
    </Layout>
  );
};

export default Main;
